import React, { useState } from 'react';
import './about2.css';
import Footer from "./footer"; 

const Frame1 = () => {
  const [showText1, setShowText1] = useState(false);
  const [showText2, setShowText2] = useState(false);
  const [showText3, setShowText3] = useState(false);
  const [showText4, setShowText4] = useState(false);
  const [showText5, setShowText5] = useState(false);

  const toggleText1 = () => {
    setShowText1(!showText1);
  };

  const toggleText2 = () => {
    setShowText2(!showText2);
  };

  const toggleText3 = () => {
    setShowText3(!showText3);
  };

  const toggleText4 = () => {
    setShowText4(!showText4);
  };

  const toggleText5 = () => {
    setShowText5(!showText5);
  };

  return (
    <div>
    <div className="frame-rootq">
      <div className="rectangle-boxq " />
      <div className="frame-innerq" />
      <div className="rectangle-divq" />
      <div className="frame-child1q" />
      <div className="frame-child2q" />
      <div className="what-makes">{`What Makes `}</div>
      <div className="us-special">Us Special</div>
      <div className="frame-child3q" />
      <div className="frame-child4q" />
      {<div className="frame-child5q" /> }
      <div className="frame-child6q" />
      <div className="user-centric-focus">USER- CENTRIC FOCUS</div>
      <div className="frame-child7q" />
      <div className="frame-child8q" />
      <div className="frame-child9q" />
      <div className="technical-expertise">TECHNICAL EXPERTISE</div>
      <div className="proven-track-records">
        <p className="proven-track">PROVEN TRACK RECORDS</p>
      </div>
      <div className="strong-support-and-container">
        <p className="strong-support-and">STRONG SUPPORT AND</p>
        <p className="strong-support-and">            SERVICE</p>
      </div>
      <div className="ethics"> ETHICS</div>
      <div className="compliance-and">{`COMPLIANCE AND `}</div>



      <div className="our-software-and" onMouseEnter={toggleText1} onMouseLeave={toggleText1}>
        <img src="/Picture11.png" alt="" />
        {showText1 && (
          <div className="image-overlay1q">
            <p>
              Our software and 3D experts create flawless VR solutions with stunning visuals and unmatched interactivity, setting industry standards.
            </p>
          </div>
        )}
      </div>

      <div className="we-thoroughly-understand" onMouseEnter={toggleText2} onMouseLeave={toggleText2}>
      <img src="/Pic222.png" alt="" />
      {showText2 && (
        <div className="image-overlay2q">
          <p>
        We thoroughly understand your audience, their needs, and the psychology of immersion to exceed user expectations in crafting compelling experiences.
        </p>
      </div>
      )}
      </div>
      <div className="we-adhere-to" onMouseEnter={toggleText3} onMouseLeave={toggleText3}>
      <img src="/333.png" alt="" />
      {showText3 && (
        <div className="image-overlay3q">
          <p>
          We adhere to the highest ethical standards, prioritizing data security and confidential information protection in all our work.
        </p>
      </div>
      )}
      </div>
      <div className="proven-success-and" onMouseEnter={toggleText4} onMouseLeave={toggleText4}>
      <img src="/4444.png" alt="" />
      {showText4 && (
        <div className="image-overlay4q">
          <p>
        Proven success and satisfied clients underpin our track record of exceptional results, making us a reliable partner to help achieve your business goals with reduced risk.
        </p>
      </div>
      )}
      </div>

      <div className="our-commitment-extends" onMouseEnter={toggleText5} onMouseLeave={toggleText5}>
      <img src="/Pic15.png" alt="" />
      {showText5 && (
        <div className="image-overlay5q">
          <p>
        Our commitment extends beyond project delivery, providing ongoing support to ensure your VR/AR experiences consistently exceed your expectations.
        </p>
      </div>
      )}
      </div>

      
  </div>
  <Footer /></div>
  );
};

const App = () => {
  return (
    <div className="App">
      <Frame1 />
    </div>
  );
};

export default App;
